export enum DiscountApplicationRuleEnum {
  APPLY_ON_GROSS_VALUE = 'APPLY_ON_GROSS_VALUE',
  APPLY_ON_PROMOTIONAL_PRICE = 'APPLY_ON_PROMOTIONAL_PRICE',
}
